/**
 * Build a 1- or 2-letter initials string from a name (org or user).
 * Falls back to '?' when nothing usable is provided.
 */
export const initialsFromName = (name: string | null | undefined): string => {
  if (!name) return '?';
  const trimmed = name.trim();
  if (!trimmed) return '?';
  const words = trimmed.split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
};
